import { RxDatabase } from 'rxdb';

import {
	Api,
	CapacityCheckSearchDirectionDto,
	deleteCapacityCheckApi,
	getCapacityCheckV2Api,
	LbodtflexCapacityCheckViewV2,
	patchCapacityCheck1Api,
	patchCapacityCheckApi,
	postCapacityCheckV2Api,
	TCapacityCheckProcessInstance,
} from '@mopla/data-models';

import {
	ILBODTFlexCapacityCheckAPI,
	TPatchSearchV2Payload,
	TPostCapacityCheckPayload,
} from './types';

function mapCapacityCheckResponse(
	data: LbodtflexCapacityCheckViewV2
): TCapacityCheckProcessInstance<'LBODTFLEX'> {
	/**
	 * TODO think how to make PrivateTripSearchView compatible with TCapacityCheckProcessInstance<'LBODTFLEX'>;
	 * In fact they are compatible
	 * */
	return data as unknown as TCapacityCheckProcessInstance<'LBODTFLEX'>;
}

export class LBODTFLEXApi implements ILBODTFlexCapacityCheckAPI {
	constructor(private api: Api, private db: RxDatabase) {}

	async postSearch(
		payload: TPostCapacityCheckPayload<'LBODTFLEX'>
	): Promise<TCapacityCheckProcessInstance<'LBODTFLEX'>> {
		const res = await postCapacityCheckV2Api({ body: payload });

		return mapCapacityCheckResponse(res.data);
	}

	async getSearch(
		capacityCheckId: string
	): Promise<TCapacityCheckProcessInstance<'LBODTFLEX'>> {
		const res = await getCapacityCheckV2Api({ path: { capacityCheckId } });

		return mapCapacityCheckResponse(res.data);
	}

	async patchSearch(
		capacityCheckId: string,
		payload: CapacityCheckSearchDirectionDto
	): Promise<void> {
		await patchCapacityCheck1Api({
			path: { capacityCheckId },
			body: payload,
		});
	}

	async patchSearchV2(
		capacityCheckId: string,
		payload: TPatchSearchV2Payload
	): Promise<TCapacityCheckProcessInstance<'LBODTFLEX'>> {
		const res = await patchCapacityCheckApi({
			path: { capacityCheckId },
			body: payload,
		});

		return mapCapacityCheckResponse(res.data);
	}

	async deleteSearch(capacityCheckId: string): Promise<void> {
		await deleteCapacityCheckApi({ path: { capacityCheckId } });
	}
}
